import "./Footer.css";
const Footer = () => {
  return (
    <div className="footer">
      <p>Copyright © 2023 by Lorena Capraru</p>
    </div>
  );
};

export default Footer;
